export default function toFraction (x) {
  if (x && x > 0) {
    const denominators = [{
      denominator: 10,
      value: 0.1
    }, {
      denominator: 3,
      value: 0.333333
    }, {
      denominator: 64,
      value: 0.015625
    }]

    let smallestDifference = null

    denominators.forEach((element) => {
      let res = Math.round(x / element.value) * element.value
      res = res - x
      if (res < 0) {
        res = res * -1
      }

      if (smallestDifference === null) {
        smallestDifference = {
          fraction: Math.round(x / element.value),
          denominator: element.denominator,
          value: res
        }
      } else if (res < smallestDifference.value) {
        smallestDifference = {
          fraction: Math.round(x / element.value),
          denominator: element.denominator,
          value: res
        }
      }
    })

    let length = 1
    for (let index = 0; index < length; index++) {
      if (
        (smallestDifference.fraction / 2 === Math.round(smallestDifference.fraction / 2)) &&
      (smallestDifference.denominator / 2 === Math.round(smallestDifference.denominator / 2))
      ) {
        length++
        smallestDifference = {
          fraction: smallestDifference.fraction / 2,
          denominator: smallestDifference.denominator / 2
        }
      }
    }
    return smallestDifference
  }
  return {
    fraction: 0,
    denominator: 0
  }
}
